import type { FC, ReactNode } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TTimerText } from '../../models/index';

type TTimerTextDisplayProps = Pick<TTimerText, 'timerText' | 'styles' | 'Text'> & {
    children: ReactNode;
    endText: string;
    startText: string;
};

export const TimerTextDisplay: FC<TTimerTextDisplayProps> = ({
    Text,
    children,
    endText,
    startText,
    styles,
    timerText,
}) => (
    <>
        {startText}
        <Text
            className={cn({ [styles.default]: !timerText })}
            noClasses={!timerText}
            tag="span"
            {...timerText}
        >
            {children}
        </Text>
        {endText}
    </>
);
